import { render, staticRenderFns } from "./UpdatePeopleType.vue?vue&type=template&id=a0625572&scoped=true"
import script from "./UpdatePeopleType.vue?vue&type=script&lang=js"
export * from "./UpdatePeopleType.vue?vue&type=script&lang=js"
import style0 from "./UpdatePeopleType.vue?vue&type=style&index=0&id=a0625572&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0625572",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a0625572')) {
      api.createRecord('a0625572', component.options)
    } else {
      api.reload('a0625572', component.options)
    }
    module.hot.accept("./UpdatePeopleType.vue?vue&type=template&id=a0625572&scoped=true", function () {
      api.rerender('a0625572', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cashinternal/UpdatePeopleType.vue"
export default component.exports